<template>
    <div>
        <CRow class="mt-4 ml-2 mr-2 mb-3">
            <CCol sm="3 d-flex">
                <div style="border-radius:8px" class="card p-0 mb-1 bg-white w-100 px-3 py-3">
                    <div class="mb-3">
                        <div class="card-title mb-1">Total Karyawan Overtime</div>
                        <div class="card-subtitle">Data pegawai yang overtime bulan ini</div>
                    </div>
                    <div class="row no-gutters">
                        <div class="col-md-6">
                            <span style="font-size: 28px;color: rgba(16, 16, 16, 1);font-weight:600" class="text-left">{{totalDatas}}</span>
                            <span style="font-size: 12px;color: rgba(154, 154, 154, 1)" class="text-left"> Pegawai</span>
                        </div>
                        <div class="col-md-6 pt-1">
                            <div class="card-emblem">
                                <img :src="totalKaryawanOvertimeIcon" width="20px" height="20px" />
                            </div>
                        </div>
                    </div>
                </div>
            </CCol>
            <CCol sm="3 d-flex">
                <div style="border-radius:8px" class="card p-0 mb-1 bg-white w-100 px-3 py-3">
                    <div class="mb-3">
                        <div class="card-title mb-1">Total Jam Overtime</div>
                        <div class="card-subtitle">Total jam overtime bulan ini</div>
                    </div>
                    <div class="row no-gutters">
                        <div class="col-md-6">
                            <span style="font-size: 28px;color: rgba(16, 16, 16, 1);font-weight:600" class="text-left">{{totalJam}}</span>
                            <span style="font-size: 12px;color: rgba(154, 154, 154, 1)" class="text-left"> Jam</span>
                        </div>
                        <div class="col-md-6 pt-1">
                            <div class="card-emblem">
                                <img :src="totalJamOvertimeIcon" width="20px" height="20px" />
                            </div>
                        </div>
                    </div>
                </div>
            </CCol>
            <CCol sm="3 d-flex">
                <div style="border-radius:8px" class="card p-0 mb-1 bg-white w-100 px-3 py-3">
                    <div class="mb-3">
                        <div class="card-title mb-1">Pending Request</div>
                        <div class="card-subtitle">Data Atasan menunggu approval</div>
                    </div>
                    <div class="row no-gutters">
                        <div class="col-md-6">
                            <span style="font-size: 28px;color: rgba(16, 16, 16, 1);font-weight:600" class="text-left">{{totalWaiting}}</span>
                            <span style="font-size: 12px;color: rgba(154, 154, 154, 1)" class="text-left"> Pegawai</span>
                        </div>
                        <div class="col-md-6 pt-1">
                            <div class="card-emblem">
                                <img :src="pendingRequestIcon" width="20px" height="20px" />
                            </div>
                        </div>
                    </div>
                </div>
            </CCol>
            <CCol sm="3 d-flex">
                <div style="border-radius:8px" class="card p-0 mb-1 bg-white w-100 px-3 py-3">
                    <div class="mb-3">
                        <div class="card-title mb-1">Ditolak</div>
                        <div class="card-subtitle">Data karyawan menolak overtime</div>
                    </div>
                    <div class="row no-gutters">
                        <div class="col-md-6">
                            <span style="font-size: 28px;color: rgba(16, 16, 16, 1);font-weight:600" class="text-left">{{totalReject}}</span>
                            <span style="font-size: 12px;color: rgba(154, 154, 154, 1)" class="text-left"> Pegawai</span>
                        </div>
                        <div class="col-md-6 pt-1">
                            <div class="card-emblem">
                                <img :src="ditolakIcon" width="20px" height="20px" />
                            </div>
                        </div>
                    </div>
                </div>
            </CCol>
        </CRow>
        <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <div class="search-area">
            <CRow class="no-gutters">
                <CCol style="padding-right:4px" sm="2">
                    <div class="autocomplete">
                        <input type="text"
                                class="form-control"
                                @click="toggleVisiblePegawai()"
                                @blur="toggleCloseVisiblePegawai()"
                                v-model="queryPegawai"
                                v-text="selectedItemPegawai ? selectedItemPegawai['text'] : ''"
                                @keydown.up="upPegawai"
                                @keydown.down="downPegawai"
                                @keydown.enter="selectItemPegawai"
                                placeholder="Pilih Pegawai"
                        >
                        <div class="popovers" v-show="visiblePegawai">
                            <div class="options" v-if="matchesPegawai.length != 0 && queryPegawai.length != 0" ref="optionsList">
                                <ul>
                                <li v-for="(match, index) in matchesPegawai"
                                    :key="index"
                                    :class="{ 'selected': (selectedPegawai == index)}"
                                    @click="itemClickedPegawai(index)"
                                    v-text="match['text']"></li>
                                </ul>
                            </div>
                            <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length != 0">
                                Data Tidak Ditemukan
                            </div>
                            <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length == 0">
                                Start Typing...
                            </div>
                        </div>
                    </div>
                </CCol>
                <CCol style="padding-right:4px;padding-left:4px" sm="2">
                    <div class="autocomplete">
                        <input type="text"
                                class="form-control"
                                @click="toggleVisibleAtasan()"
                                @blur="toggleCloseVisibleAtasan()"
                                v-model="queryAtasan"
                                v-text="selectedItemAtasan ? selectedItemAtasan['text'] : ''"
                                @keydown.up="upAtasan"
                                @keydown.down="downAtasan"
                                @keydown.enter="selectItemAtasan"
                                placeholder="Pilih Atasan"
                        >
                        <div class="popovers" v-show="visibleAtasan">
                            <div class="options" v-if="matchesAtasan.length != 0 && queryAtasan.length != 0" ref="optionsList">
                                <ul>
                                <li v-for="(match, index) in matchesAtasan"
                                    :key="index"
                                    :class="{ 'selected': (selectedAtasan == index)}"
                                    @click="itemClickedAtasan(index)"
                                    v-text="match['text']"></li>
                                </ul>
                            </div>
                            <div class="options" v-if="matchesAtasan.length == 0 && queryAtasan.length != 0">
                                Data Tidak Ditemukan
                            </div>
                            <div class="options" v-if="matchesAtasan.length == 0 && queryAtasan.length == 0">
                                Start Typing...
                            </div>
                        </div>
                    </div>
                </CCol>
                <CCol style="padding-right:4px;padding-left:4px" sm="2">
                    <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataStatus" class="form-control" v-model="selectedStatus" placeholder="Pilih Status"></model-select>
                </CCol>
                <CCol sm="2" style="padding-right:4px;padding-left:4px">
                    <input type="text" onfocus="(this.type='date')" onblur="(this.type='text')" placeholder="Tanggal Mulai" v-model="dateStart" class="form-control"/>
                </CCol>
                <CCol sm="2" style="padding-right:4px;padding-left:4px">
                    <input type="text" onfocus="(this.type='date')" onblur="(this.type='text')" placeholder="Tanggal Selesai" v-model="dateEnd" class="form-control"/>
                </CCol>
                <CCol style="padding-left:4px" sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow class="no-gutters">
                <CCol sm="4" style="padding-right:4px;float:left">
                    <img class="mr-4 mt-1" @click="reload()" title="refresh" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="cursor:pointer;float:left"/>
                    <img class="mr-4 mt-1" v-if="datas.length != 0" @click="getDownload()" style="float:left;cursor:pointer" :src="downloadIcon" title="export to excel"  width="20px" height="20px"/>
                    <img class="mr-4 mt-1" style="float:left" :src="moreIcon" width="20px" height="20px"/>
                </CCol>
                <CCol style="padding-right:4px;padding-left:4px" sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                </CCol>
                <CCol style="padding-left:4px" sm="2">
                    <CButton @click="addModal = true" type="button" class="btn btn-add">Buat</CButton>
                </CCol>
            </CRow>
        </div>
        <Tables @sort="sorting" @detail="detailData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
        <CModal
            size="lg"
            :centered="true"
            color="white"
            :show.sync="detailModal"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Detail E-Overtime {{viewNama}}</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="closeModal()" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding-right:20px;padding-left:20px">
                    <CRow>
                        <CCol sm="3">
                            Nama
                        </CCol>
                        <CCol sm="9">
                            : <span class="font-weight-bold">{{viewNama}}</span>
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="3">
                            Tanggal Overtime
                        </CCol>
                        <CCol sm="9">
                            : {{viewTanggal}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="3">
                            Mulai overtime
                        </CCol>
                        <CCol sm="9">
                            : {{viewMulai}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="3">
                            Selesai overtime
                        </CCol>
                        <CCol sm="9">
                            : {{viewSelesai}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="3">
                            Total Jam overtime
                        </CCol>
                        <CCol sm="9">
                            : {{viewTotal}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-3">
                        <CCol sm="12">
                            <p class="font-weight-bold">Riwayat</p>
                            <CRow class="mt-2 mb-5">
                                <CCol sm="12">
                                    <ul class="StepProgress">
                                        <li class="StepProgress-item" v-for="(item, index) in viewHistory" :key="'track'+index" :class="[item.selesai != 'Y' ? 'is-done' : '']">
                                            <div>
                                                <span :style="{ color : item.color }" class="font-weight-bold">{{item.action}}</span>
                                            </div>
                                            <div>by {{item.namaPegawai}} at {{item.tanggal}}</div>
                                            <div>{{item.keterangan}}</div>
                                        </li>
                                    </ul>
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="2">
                            <CButton v-if="viewReject == '100'" @click="pdfPreview()" color="primary" variant="outline">SPKL PDF</CButton>
                        </CCol>
                    </CRow>
                </div>
                <CRow class="mt-5" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                    <CCol sm="12">
                        <CButton v-if="viewReject == '98'" @click="reOpen()" style="float:right" class="modal-button-simpan ml-2">
                            <span v-if="loading == false">Reopen</span>
                            <CSpinner v-else color="default" size="sm"/>
                        </CButton>
                        <CButton @click="closeModal()" style="float:right" class="modal-button-cancel">Kembali</CButton>
                    </CCol>
                </CRow>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
        <CModal
            size="lg"
            :centered="true"
            color="white"
            :show.sync="addModal"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Buat E-Overtime</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="closeAddModal()" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding-right:20px;padding-left:20px">
                    <CRow>
                        <CCol sm="6">
                            <label class="mb-1">Nama Pegawai</label>
                            <div class="autocomplete">
                                <input type="text"
                                        class="form-control"
                                        @click="toggleVisibleAddPegawai()"
                                        @blur="toggleCloseVisibleAddPegawai()"
                                        v-model.trim="$v.queryAddPegawai.$model"
                                        :class="{ 'is-invalid':$v.queryAddPegawai.$error, 'is-valid': !$v.queryAddPegawai.$invalid }" 
                                        v-text="selectedItemAddPegawai ? selectedItemAddPegawai['text'] : ''"
                                        @keydown.up="upAddPegawai"
                                        @keydown.down="downAddPegawai"
                                        @keydown.enter="selectItemAddPegawai"
                                        placeholder="Pilih Pegawai"
                                >
                                <div class="popovers" v-show="visibleAddPegawai">
                                    <div class="options" v-if="matchesAddPegawai.length != 0 && queryAddPegawai.length != 0" ref="optionsList">
                                        <ul>
                                        <li v-for="(match, index) in matchesAddPegawai"
                                            :key="index"
                                            :class="{ 'selected': (selectedAddPegawai == index)}"
                                            @click="itemClickedAddPegawai(index)"
                                            v-text="match['text']"></li>
                                        </ul>
                                    </div>
                                    <div class="options" v-if="matchesAddPegawai.length == 0 && queryAddPegawai.length != 0">
                                        Data Tidak Ditemukan
                                    </div>
                                    <div class="options" v-if="matchesAddPegawai.length == 0 && queryAddPegawai.length == 0">
                                        Start Typing...
                                    </div>
                                </div>
                            </div>
                        </CCol>
                        <CCol sm="6">
                            <label class="mb-1">NIP</label>
                            <input
                            v-model.trim="$v.addNip.$model"
                            :class="{ 'is-invalid':$v.addNip.$error, 'is-valid': !$v.addNip.$invalid }" 
                            placeholder="Nomor Induk Pegawai" 
                            disabled 
                            class="form-control" />
                        </CCol>
                    </CRow>
                    <CRow class="mt-3">
                        <CCol sm="6">
                            <label class="mb-1">Tanggal</label>
                            <input
                            v-model.trim="$v.addTanggal.$model"
                            :class="{ 'is-invalid':$v.addTanggal.$error, 'is-valid': !$v.addTanggal.$invalid }" 
                            placeholder="Tanggal Overtime" 
                            type="date" 
                            class="form-control" />
                        </CCol>
                        <CCol sm="6">
                            <label class="mb-1">Jenjang Jabatan</label>
                            <input
                            v-model="addJabatan"
                            placeholder="Jenjang Jabatan" 
                            disabled 
                            class="form-control" />
                        </CCol>
                    </CRow>
                    <CRow class="mt-3">
                        <CCol sm="6">
                            <label class="mb-1">Jam Mulai</label>
                            <input type="time"
                            v-model.trim="$v.addMulai.$model"
                            :class="{ 'is-invalid':$v.addMulai.$error, 'is-valid': !$v.addMulai.$invalid }" 
                            placeholder="Jam Mulai" 
                            class="form-control" />
                        </CCol>
                        <CCol sm="6">
                            <label class="mb-1">Jam Selesai</label>
                            <input type="time"
                            v-model.trim="$v.addSelesai.$model"
                            :class="{ 'is-invalid':$v.addSelesai.$error, 'is-valid': !$v.addSelesai.$invalid }" 
                            placeholder="Jam Selesai" 
                            class="form-control" />
                        </CCol>
                    </CRow>
                    <CRow class="mt-3">
                        <CCol sm="6">
                            <label class="mb-1">Komentar</label>
                            <textarea 
                            v-model.trim="$v.addKomentar.$model"
                            :class="{ 'is-invalid':$v.addKomentar.$error, 'is-valid': !$v.addKomentar.$invalid }" 
                            placeholder="Masukan Komentar ..." 
                            class="form-control"/>
                        </CCol>
                    </CRow>
                    <CRow class="mt-3">
                        <CCol sm="6">
                            <label class="mb-1">Attachment</label>
                            <model-select 
                                :options="dataFile" 
                                class="form-control" 
                                v-model.trim="$v.selectedFile.$model" 
                                :class="{ 'is-invalid select-invalid':$v.selectedFile.$error, 'is-valid select-valid': !$v.selectedFile.$invalid }"
                                placeholder="Pilih File">
                            </model-select>
                        </CCol>
                    </CRow>
                    <CRow class="mt-3 mb-5" v-if="selectedFile.value == '1'">
                        <CCol sm="6">
                            <label class="mb-1">Foto(.jpg. .png, .bmp, .jpeg) *maks. size 2MB</label>
                            <div class="mb-5" v-if="urlImage == '' || urlImage == 'null'">
                                <input v-on:change="onFileChange" style="position:absolute;opacity:0;z-index:1;cursor:pointer" type="file" class="mr-2" accept=".jpg, .png, .bmp, .jpeg" />
                                <div class="cards-image" :class="{ 'is-invalid cards-image-invalid':$v.urlImage.$error, 'is-valid cards-image': !$v.urlImage.$invalid }">+</div>
                            </div>
                            <div class="mb-5" v-else>
                                <img :src="urlImage" width="56" height="56" />
                                <button @click="removeImage()" class="ml-3 btn btn-danger" size="sm">Delete</button>
                            </div>
                        </CCol>
                    </CRow>
                    <CRow class="mt-3 mb-5" v-if="selectedFile.value == '2'">
                        <CCol sm="6">
                            <label class="mb-1">File Pdf *maks. size 2MB</label>
                            <div>
                                <CButton v-if="file == ''" type="button" onclick="document.getElementById('inputFile').click()" class="btn btn-cancel">Pilih Dokumen</CButton>
                                <input type="file" accept=".pdf, .PDF" @change="loadFile()" style="display:none"  id="inputFile" class="hide" />
                            </div>
                            <!--  -->
                            <p v-if="file != ''" class="font-weight-bold"><span class="mr-3">{{fileName}}</span><CButton class="mr-2" @click="removeFile()" color="danger">Hapus</CButton></p>
                        </CCol>
                    </CRow>
                    <CRow class="mt-5 mb-5">
                        <CCol sm="6"></CCol>
                        <CCol sm="3">
                            <CButton style="width:100%!important" @click="closeAddModal()" class="modal-button-cancel">Kembali</CButton>
                        </CCol>
                        <CCol sm="3">
                            <CButton style="width:100%!important" @click="submitForm()" class="modal-button-simpan">Buat</CButton>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
    </div>
</template>

<script>
import Tables from '../../../component/tableOvertime'
import {DataApi, DataApiUpload} from "../../../service/DataApi";
import { ModelSelect } from 'vue-search-select' 
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'

const xlsx = require('json-as-xlsx')
export default {
    components: {
        Tables,
        ModelSelect
    },
    mixins: [validationMixin],
    validations: {
        queryAddPegawai: {
            required
        },
        addNip: {
            required
        },
        addMulai: {
            required
        },
        addSelesai: {
            required
        },
        addTanggal: {
            required
        },
        addKomentar: {
            required
        },
        selectedFile: {
            text: {
                required
            },
            value: {
                required
            }
        },
        urlImage: {
            required
        },
    },
    data() {
        return {
            success:true,
            loading: false,
            currentAlertCounter: 0,
            alertMess: '',
            loading: false,

            // data search pegawai
            dataPegawai: [],
            titlePegawai:"Pilih Pegawai",
            selectedItemPegawai: null,
            selectedPegawai: 0,
            queryPegawai: '',
            visiblePegawai: false,

            // data search atasan
            dataAtasan: [],
            titleAtasan:"Pilih Atasan",
            selectedItemAtasan: null,
            selectedAtasan: 0,
            queryAtasan: '',
            visibleAtasan: false,

            totalKaryawanOvertimeIcon: require('../../../assets/menu/icon_overtime_2.svg'),
            totalJamOvertimeIcon: require('../../../assets/menu/icon_overtime_3.svg'),
            closeIcon: require('../../../assets/menu/icon_close.svg'),
            pendingRequestIcon: require('../../../assets/menu/icon_overtime_4.svg'),
            ditolakIcon: require('../../../assets/menu/icon_overtime_1.svg'),
            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            downloadIcon: require('../../../assets/menu/icon_download_excel.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),

            dataTh: ['Nama Pegawai', 'Tanggal', 'Jam', 'Total', 'Keterangan', 'Status'],
            dataTd: ['namaPegawai', 'tanggalPengajuan', 'jamPengajuan', 'totalJam', 'keterangan', 'approve'],
            styleTable: ['150px', '75px', '75px', '75px', '225px', '150px'],
            classReload: 'reloadOff',

            totalDatas: 0,
            totalJam: 0,
            totalWaiting: 0,
            totalReject: 0,

            // paging
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // filter
            dateStart: '',
            dateEnd: '',
            dataStatus: [],
            selectedStatus: {
                value: '',
                text: ''
            },

            // datas
            datas: [],
            // error
            errorMessage: '',

            // modal
            detailModal: false,
            viewNama: '',
            viewMulai: '',
            viewTanggal: '',
            viewSelesai: '',
            viewTotal: '',
            viewStatus: '',
            viewHistory: '',
            viewReject: '',
            viewUnix: '',

            addModal: false,
            addNip: '',
            addJabatan: '',
            addMulai: '',
            addSelesai: '',
            addTanggal: '',
            addKomentar: '',
            dataFile: [],
            selectedFile: {
                text: '',
                value: ''
            },
            lvl: '',
            organisasi: '',

            urlImage: '',
            urlPath: '',
            showImage: '',
            file: '',
            fileName: '',
            fileSize: '',
            urlFile: '',

            // data add pegawai
            dataAddPegawai: [],
            titleAddPegawai:"Pilih Pegawai",
            selectedItemAddPegawai: null,
            selectedAddPegawai: 0,
            queryAddPegawai: '',
            visibleAddPegawai: false,
            idAddPegawai: '',

            flagSearch: false
        }
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        queryPegawai() {
            this.flagSearch = true
            this.getDataPegawai()
        },
        queryAtasan() {
            this.flagSearch = true
            this.getDataAtasan()
        },
        queryAddPegawai() {
            if(this.queryAddPegawai == '') {
                this.idAddPegawai = ''
                this.addNip = ''
                this.addJabatan = ''
            }
            this.getDataAddPegawai()
        },
        dateStart() {
            this.flagSearch = true
        },
        dateEnd() {
            this.flagSearch = true
        },
        selectedStatus() {
            this.flagSearch = true
        },
        selectedFile() {
            if(this.selectedFile.value == '1') {
                this.clearFile()
            } else if(this.selectedFile.value == '2') {
                this.removeImage()
            }
        }
    },
    computed: {
        matchesAddPegawai() {
            if (this.queryAddPegawai == '') {
                return [];
            }
            return this.dataAddPegawai.filter((item) => item['text'].toLowerCase().includes(this.queryAddPegawai.toLowerCase()))
        },
        matchesPegawai() {
            if (this.queryPegawai == '') {
                return [];
            }
            return this.dataPegawai.filter((item) => item['text'].toLowerCase().includes(this.queryPegawai.toLowerCase()))
        },
        matchesAtasan() {
            if (this.queryAtasan == '') {
                return [];
            }
            return this.dataAtasan.filter((item) => item['text'].toLowerCase().includes(this.queryAtasan.toLowerCase()))
        },
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.getDataAddPegawai()
        this.getDataPegawai()
        this.getDataAtasan()
        this.getDataRekap()
        this.getDataStatus()
        this.getDataFile()
        this.getDataToken()
    },
    methods: {
        /**
         * SEARCH PEGAWAI
         */
        getDataPegawai() {
            let payload = {
                bidang: '',
                jabatan: '',
                limit: 10,
                nama: this.queryPegawai,
                pageIn: 1,
                pegawaiId: '',
                tipePegawai: ''
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataPegawai = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].nik,
                        text: tempData[i].nama + ' - ' + tempData[i].nik
                    }
                    this.dataPegawai.push(onPush)
                }
            })
        },
        toggleVisiblePegawai() {
            this.visiblePegawai = true;
        },
        hidePegawai() {
            this.visiblePegawai = false;
        },
        toggleCloseVisiblePegawai() {
            setTimeout(this.hidePegawai, 1000);
        },
        itemClickedPegawai(index) {
            this.selectedPegawai = index;
            this.selectItemPegawai();
        },
        selectItemPegawai() {
            if (!this.matchesPegawai.length) {
            return;
            }
            this.selectedItemPegawai = this.matchesPegawai[this.selectedPegawai];
            this.visiblePegawai = false;
            this.queryPegawai = this.selectedItemPegawai.text
            if (this.shouldReset) {
            this.queryPegawai = '';
            this.selectedPegawai = 0;
            }
        },
        upPegawai() {
            if (this.selectedPegawai == 0) {
            return;
            }
            this.selectedPegawai -= 1;
            this.scrollToItemPegawai();
        },
        downPegawai() {
            if (this.selectedPegawai >= this.matchesPegawai.length - 1) {
            return;
            }
            this.selectedPegawai += 1;
            this.scrollToItemPegawai();
        },
        scrollToItemPegawai() {
            this.$refs.optionsList.scrollTop = this.selectedPegawai * this.itemHeight;
        },

        /**
         * SEARCH ATASAN
         */
        getDataAtasan() {
            let payload = {
                bidang: '',
                jabatan: '',
                limit: 10,
                nama: this.queryAtasan,
                pageIn: 1,
                pegawaiId: '',
                tipePegawai: ''
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataAtasan = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].nik,
                        text: tempData[i].nama + ' - ' + tempData[i].nik
                    }
                    this.dataAtasan.push(onPush)
                }
            })
        },
        toggleVisibleAtasan() {
            this.visibleAtasan = true;
        },
        hideAtasan() {
            this.visibleAtasan = false;
        },
        toggleCloseVisibleAtasan() {
            setTimeout(this.hideAtasan, 1000);
        },
        itemClickedAtasan(index) {
            this.selectedAtasan = index;
            this.selectItemAtasan();
        },
        selectItemAtasan() {
            if (!this.matchesAtasan.length) {
            return;
            }
            this.selectedItemAtasan = this.matchesAtasan[this.selectedAtasan];
            this.visibleAtasan = false;
            this.queryAtasan = this.selectedItemAtasan.text
            if (this.shouldReset) {
            this.queryAtasan = '';
            this.selectedAtasan = 0;
            }
        },
        upAtasan() {
            if (this.selectedAtasan == 0) {
            return;
            }
            this.selectedAtasan -= 1;
            this.scrollToItemAtasan();
        },
        downAtasan() {
            if (this.selectedAtasan >= this.matchesAtasan.length - 1) {
            return;
            }
            this.selectedAtasan += 1;
            this.scrollToItemAtasan();
        },
        scrollToItemAtasan() {
            this.$refs.optionsList.scrollTop = this.selectedAtasan * this.itemHeight;
        },

        getDataStatus() {
            this.dataStatus = [{ value: '', text: 'Semua' }]
            let payload = {
                aktif: "1",
                description: "",
                fieldReason: "",
                isApproval: "",
                isPegawaiAtasan: "",
                limit: 9999,
                nama: "",
                modul: "1",
                pageIn: 1
            }
            DataApi.post("overtime/status/approval/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    let datas = response.data.data
                    var i
                    for(i=0;i<datas.length;i++) {
                        let onPush = {
                            value: datas[i].unix,
                            text: datas[i].nama
                        }
                        this.dataStatus.push(onPush)
                    }
                }
            })
        },


        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.namaPegawai.toLowerCase() < b.namaPegawai.toLowerCase()) {
                        return -1
                    }
                    if (a.namaPegawai.toLowerCase() > b.namaPegawai.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.pengajuanStart.toLowerCase() < b.pengajuanStart.toLowerCase()) {
                        return -1
                    }
                    if (a.pengajuanStart.toLowerCase() > b.pengajuanStart.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 2) {
                function compare(a,b) {
                    if (a.pengajuganEnd.toLowerCase() < b.pengajuganEnd.toLowerCase()) {
                        return -1
                    }
                    if (a.pengajuganEnd.toLowerCase() > b.pengajuganEnd.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 3) {
                function compare(a,b) {
                    if (a.totalJam.toLowerCase() < b.totalJam.toLowerCase()) {
                        return -1
                    }
                    if (a.totalJam.toLowerCase() > b.totalJam.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 4) {
                function compare(a,b) {
                    if (a.tanggalInsert.toLowerCase() < b.tanggalInsert.toLowerCase()) {
                        return -1
                    }
                    if (a.tanggalInsert.toLowerCase() > b.tanggalInsert.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 5) {
                function compare(a,b) {
                    if (a.tanggalApprove.toLowerCase() < b.tanggalApprove.toLowerCase()) {
                        return -1
                    }
                    if (a.tanggalApprove.toLowerCase() > b.tanggalApprove.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 6) {
                function compare(a,b) {
                    if (a.namaAtasanPegawai.toLowerCase() < b.namaAtasanPegawai.toLowerCase()) {
                        return -1
                    }
                    if (a.namaAtasanPegawai.toLowerCase() > b.namaAtasanPegawai.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 7) {
                function compare(a,b) {
                    if (a.keterangan.toLowerCase() < b.keterangan.toLowerCase()) {
                        return -1
                    }
                    if (a.keterangan.toLowerCase() > b.keterangan.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 8) {
                function compare(a,b) {
                    if (a.approve.toLowerCase() < b.approve.toLowerCase()) {
                        return -1
                    }
                    if (a.approve.toLowerCase() > b.approve.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let limit = this.size
            let namaAtasanPegawai = this.queryAtasan.split(" - ")[0]
            let namaPegawai = this.queryPegawai.split(" - ")[0]
            let page = this.page
            
            let start = this.dateStart
            let end = this.dateEnd
            let tanggalMulai = ''
            let tanggalSelesai = ''
            if(start == '' && end == '') {
                let currentDate = new Date()
                let firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
                let lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
                tanggalMulai = firstDay.getFullYear() + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate()
                tanggalSelesai = lastDay.getFullYear() + '-' + (lastDay.getMonth() + 1) + '-' + lastDay.getDate()
            } else if(start == '' && end != '') {
                let myPastDate = new Date(end);
                myPastDate.setDate(myPastDate.getDate() - 30)
                tanggalMulai = myPastDate.getFullYear() + '-' + (myPastDate.getMonth() + 1) + '-' + myPastDate.getDate()
                tanggalSelesai = end
            } else if(start != '' && end == '') {
                let myFutureDate = new Date(start);
                myFutureDate.setDate(myFutureDate.getDate() + 30)
                tanggalMulai = start
                tanggalSelesai = myFutureDate.getFullYear() + '-' + (myFutureDate.getMonth() + 1) + '-' + myFutureDate.getDate()
            } else if(start != '' && end != '') {
                tanggalMulai = start
                tanggalSelesai = end
            }

            let status = this.selectedStatus.value

            let payload = {
                limit: limit,
                namaAtasanPegawai: namaAtasanPegawai,
                pageIn: page,
                status: status,
                namaPegawai: namaPegawai,
                tanggalMulai: tanggalMulai,
                tanggalSelesai: tanggalSelesai
            }
            DataApi.post("overtime/backoffice/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        getDownload() {
            if(this.datas.length != 0) {
                this.$store.state.loadingScreen = true
                let limit = this.totalRow
                let namaAtasanPegawai = this.queryAtasan.split(" - ")[0]
                let namaPegawai = this.queryPegawai.split(" - ")[0]
                let page = 1
                
                let start = this.dateStart
                let end = this.dateEnd
                let tanggalMulai = ''
                let tanggalSelesai = ''
                if(start == '' && end == '') {
                    let currentDate = new Date()
                    let firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
                    let lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
                    tanggalMulai = firstDay.getFullYear() + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate()
                    tanggalSelesai = lastDay.getFullYear() + '-' + (lastDay.getMonth() + 1) + '-' + lastDay.getDate()
                } else if(start == '' && end != '') {
                    let myPastDate = new Date(end);
                    myPastDate.setDate(myPastDate.getDate() - 30)
                    tanggalMulai = myPastDate.getFullYear() + '-' + (myPastDate.getMonth() + 1) + '-' + myPastDate.getDate()
                    tanggalSelesai = end
                } else if(start != '' && end == '') {
                    let myFutureDate = new Date(start);
                    myFutureDate.setDate(myFutureDate.getDate() + 30)
                    tanggalMulai = start
                    tanggalSelesai = myFutureDate.getFullYear() + '-' + (myFutureDate.getMonth() + 1) + '-' + myFutureDate.getDate()
                } else if(start != '' && end != '') {
                    tanggalMulai = start
                    tanggalSelesai = end
                }

                let status = this.selectedStatus.value

                let payload = {
                    limit: limit,
                    namaAtasanPegawai: namaAtasanPegawai,
                    pageIn: page,
                    status: status,
                    namaPegawai: namaPegawai,
                    tanggalMulai: tanggalMulai,
                    tanggalSelesai: tanggalSelesai
                }
                DataApi.post("overtime/backoffice/lihat", payload)
                .then(res => {
                    let response = res.data
                    if(response.success == true) {
                        let downloads = response.data.data
                        let fileName = 'Rekapitulasi E-Overtime' + tanggalMulai + ' - ' + tanggalSelesai
                        let data = [
                            {
                                sheet: 'Overtime',
                                columns: [
                                    { label: 'Nama Pegawai', value: 'namaPegawai'  },
                                    { label: 'Nomor Induk Pegawai', value: 'nik'  },
                                    { label: 'Tanggal', value: 'tanggalExport' },
                                    { label: 'Jadwal Jam Mulai', value: 'jamMulaiExport' },
                                    { label: 'Jadwal Jam Selesai', value: 'jamSelesaiExport' },
                                    { label: 'Realisasi Check In', value: 'ciRealisasi' },
                                    { label: 'Realisasi Check Out', value: 'coRealisasi'},
                                    { label: 'Total Jam', value: 'totalJam'},
                                    { label: 'Request At', value: 'tanggalInsert'},
                                    { label: 'Approve At', value: 'tanggalApprove'},
                                    { label: 'Approve By', value: 'namaAtasanPegawai'},
                                    { label: 'Keterangan', value: 'keterangan'},
                                    { label: 'Status', value: 'approve'}
                                ],
                                content: downloads
                            }
                        ]
                        let settings = {
                            fileName: fileName
                        }
                        xlsx(data, settings)
                    }
                    this.$store.state.loadingScreen = false
                })
            }
        },
        getDataRekap() {
            let payload = {}
            DataApi.post("overtime/backoffice/summary_lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    let temp = response.data[0]
                    if(temp.totalPegawai != 'null') {
                        this.totalDatas = temp.totalPegawai
                    } else {
                        this.totalDatas = 0
                    }
                    if(temp.totalJam != 'null') {
                        this.totalJam = temp.totalJam
                    } else {
                        this.totalJam = 0
                    }
                    if(temp.waiting != 'null') {
                        this.totalWaiting = temp.waiting
                    } else {
                        this.totalWaiting = 0
                    }
                    if(temp.reject != 'null') {
                        this.totalReject = temp.reject
                    } else {
                        this.totalReject = 0
                    }
                }
            })
        },
        findData() {
            this.getData()
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
        reload() {
            this.dateStart = ''
            this.dateEnd = ''
            this.queryAtasan = ''
            this.queryPegawai = ''
            this.selectedStatus.value = ''
            this.selectedStatus.text = ''
            this.flagSearch = true
            this.getDataStatus()
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },
        detailData(value) {
            let generate = this.datas[value]
            this.viewNama = generate.namaPegawai
            this.viewTanggal = generate.tanggalPengajuan
            this.viewMulai = generate.jamMulaiExport
            this.viewSelesai = generate.jamSelesaiExport
            this.viewTotal = generate.totalJam
            let riwayat = generate.history
            let length = (riwayat.length)-1
            this.viewHistory = riwayat
            this.viewReject = riwayat[length].kodeStatus
            this.viewUnix = generate.unix
            this.detailModal = true
        },
        closeModal() {
            this.viewNama = ''
            this.viewMulai = ''
            this.viewSelesai = ''
            this.viewTotal = ''
            this.viewHistory = ''
            this.viewReject = ''
            this.viewUnix = ''
            this.detailModal = false
        },
        reOpen() {
            this.loading = true
            let payload = {
                unix: this.viewUnix
            }
            DataApi.post("overtime/reopen", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.closeModal()
                this.getData()
                this.loading = false
                this.currentAlertCounter = 7
            })
        },
        pdfPreview() {
            this.$store.state.loadingScreen = true
            let payload = {
                unix: this.viewUnix
            }
            DataApi.post("/export/overtime/lihat/pdf", payload , {responseType: 'blob'})
            .then(res => {
                let response = res.data
                const url = URL.createObjectURL(new Blob([response], {
                    type: 'application/pdf'
                }))
                window.open(url)
                this.$store.state.loadingScreen = false
            })
        },


        /**
         * SEARCH PEGAWAI
         */
        getDataAddPegawai() {
            let payload = {
                nama: this.queryAddPegawai,
            }
            DataApi.post("pegawai/overtime/lihat", payload)
            .then(res => {
                this.dataAddPegawai = []
                let response = res.data
                let tempData = response.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].idPegawai,
                        text: tempData[i].nama + ' - ' + tempData[i].nik,
                        nip: tempData[i].nik,
                        jabatan: tempData[i].jenjangJabatan
                    }
                    this.dataAddPegawai.push(onPush)
                }
            })
        },
        toggleVisibleAddPegawai() {
            this.visibleAddPegawai = true;
        },
        hideAddPegawai() {
            this.visibleAddPegawai = false;
        },
        toggleCloseVisibleAddPegawai() {
            setTimeout(this.hideAddPegawai, 1000);
        },
        itemClickedAddPegawai(index) {
            this.selectedAddPegawai = index;
            this.selectItemAddPegawai();
        },
        selectItemAddPegawai() {
            if (!this.matchesAddPegawai.length) {
            return;
            }
            this.selectedItemAddPegawai = this.matchesAddPegawai[this.selectedAddPegawai];
            this.visibleAddPegawai = false;
            this.queryAddPegawai = this.selectedItemAddPegawai.text
            this.idAddPegawai = this.selectedItemAddPegawai.value
            this.addNip = this.selectedItemAddPegawai.nip
            this.addJabatan = this.selectedItemAddPegawai.jabatan
            if (this.shouldReset) {
            this.queryAddPegawai = '';
            this.selectedAddPegawai = 0;
            }
        },
        upAddPegawai() {
            if (this.selectedAddPegawai == 0) {
            return;
            }
            this.selectedAddPegawai -= 1;
            this.scrollToItemAddPegawai();
        },
        downAddPegawai() {
            if (this.selectedAddPegawai >= this.matchesAddPegawai.length - 1) {
            return;
            }
            this.selectedAddPegawai += 1;
            this.scrollToItemAddPegawai();
        },
        scrollToItemAddPegawai() {
            this.$refs.optionsList.scrollTop = this.selectedAddPegawai * this.itemHeight;
        },
        closeAddModal() {
            this.addNip = ''
            this.addJabatan = ''
            this.addMulai = ''
            this.addSelesai = ''
            this.addTanggal = ''
            this.addKomentar = ''
            this.urlImage = ''
            this.urlPath = ''
            this.showImage = '',
            this.file = '',
            this.fileName = '',
            this.fileSize = '',
            this.urlFile = '',
            this.idAddPegawai = '',
            this.queryAddPegawai = '',
            this.selectedFile.text = ''
            this.selectedFile.value = ''
            this.dataFile =[]
            this.getDataFile()
            this.$v.$reset()
            this.addModal = false
        },
        getDataFile() {
            this.dataFile = [
                { text: 'Foto', value: '1' },
                { text: 'File Pdf', value: '2' }
            ]
        },
        getDataToken() {
            this.$store.state.loadingScreen = true
            DataApi.get("pegawai/role/cek")
            .then( response => {
                let res = response.data
                if(res.success == true) {
                    this.lvl = res.data.lvl
                    this.organisasi = res.data.organisasi
                }
                this.$store.state.loadingScreen = false
            })
        },
        /**
         * IMAGE
         */
        onFileChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            if(parseInt(files[0].size) > 2000000) {
                alert("Maaf, Maksimal Foto 2MB")
            } else {
                this.showImage = files[0];
                this.createImage(files[0]);
            }
        },
        createImage(file) {
            let reader = new FileReader();
            reader.onload = (e) => {
                this.urlImage = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        saveImage() {
            if (this.urlImage.split(":")[0] == 'data' && this.urlImage != '') {
                let imageData = this.showImage
                let idPegawaiData = 0
                let inOutData = "1"
                let kodePerusahaanData = this.organisasi
                let tanggalData = new Date()
                let lvlData = this.lvl

                const fd = new FormData()
                fd.append('file', imageData)
                fd.append('idPegawai', idPegawaiData)
                fd.append('inOut', inOutData)
                fd.append('kodePerusahaan', kodePerusahaanData)
                fd.append('tanggal', tanggalData)
                fd.append('lvl', lvlData)

                DataApiUpload.post('upload/file', fd)
                .then(res => {
                    let response = res.data
                    if(response.success == true) {
                        this.urlPath = response.data.urlPath
                        this.goSave()
                    } else {
                        alert('Upload Photo Failed !')
                    }
                });
            } else if(this.urlImage == '') {
                this.urlPath = ''
                this.goSave()
            } else {
                this.urlPath = this.urlImage
                this.goSave()
            }
        },
        removeImage() {
            this.showImage = ''
            this.urlImage = ''
            this.urlPath = ''
        },

        /**
         * PDF
         */
        loadFile(e) {
            let files = document.getElementById('inputFile').files[0]
            this.file = files
            this.fileName = files.name
            this.fileSize = files.size
            if(parseInt(this.fileSize) > 2000000) {
                alert("Maaf, Maksimal lampiran 2MB")
                setTimeout(this.clearFile, 200);
            }
        },
        prosessUpload() {
            if (this.file != '') {
                let imageData = this.file

                const fd = new FormData()
                fd.append('file', imageData)

                DataApiUpload.post('upload', fd)
                .then(res => {
                    let response = res.data
                    if(response.success == true) {
                        this.urlFile = response.data.path
                        this.goSave()
                    } else {
                        alert('Upload File Failed !')
                    }
                });
            } else if(this.file == '') {
                this.urlFile = ''
            }
        },
        removeFile() {
            this.file = ''
            this.fileName = ''
            this.fileSize = ''
        },
        clearFile() {
            this.fileName = ''
            this.fileSize = ''
            this.urlFile = ''
            this.file = ''
        },

        submitForm() {
            this.$v.$touch()
            if(this.$v.$invalid) {
                if(this.selectedFile.value == '1') {
                    if(this.file == '') {
                        this.saveImage()
                        this.loading = true
                        this.$store.state.loadingScreen = true
                    }
                } else if(this.selectedFile.value == '2') {
                    if(this.$v.urlImage.$invalid && this.file != '') {
                        this.prosessUpload()
                        this.loading = true
                        this.$store.state.loadingScreen = true
                    }
                }
            } else {
                if(this.selectedFile.value == '1') {
                    this.saveImage()
                    this.$store.state.loadingScreen = true
                } else if(this.selectedFile.value == '2' && this.file != '') {
                    this.prosessUpload()
                    this.$store.state.loadingScreen = true
                }
                this.loading = true
            }
        },
        goSave() {
            let attach = ''
            if(this.selectedFile.value == '1') {
                attach = this.urlPath
            } else {
                attach = this.urlFile
            }
            let payload = {
                idPegawai: this.idAddPegawai,
                jamMulai: this.addMulai,
                jamSelesai: this.addSelesai,
                keterangan: this.addKomentar,
                tanggal: this.addTanggal,
                urlFile: attach
            }
            DataApi.post("overtime/simpan", payload)
            .then( response => {
                let res = response.data
                if(res.success == true) {
                    if(res.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = res.data.Data2
                } else {
                    this.alertMess = res.message
                    this.success = false
                }
                this.getData()
                this.closeAddModal()
                this.currentAlertCounter = 7
                this.$store.state.loadingScreen = false
            })
        }
    },
}
</script>

<style scoped>
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.card-title {
    font-size: 16px;
    font-weight: 600;
    color: rgba(16, 16, 16, 1);
}
.card-subtitle {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
}
.card-emblem {
    float:right;
    background-color:rgba(48, 107, 221, 0.05);
    text-align: center;
    line-height: 32px;
    min-width:40px;
    min-height:40px;
    border-radius:50%;
}
@media screen and (min-width: 1253px) and (max-width: 1358px) {
    .inputs-form {
        float:left;
        width:40%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1168px) and (max-width: 1252px) {
    .inputs-form {
        float:left;
        width:39%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1097px) and (max-width: 1167px) {
    .inputs-form {
        float:left;
        width:38%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1036px) and (max-width: 1096px) {
    .inputs-form {
        float:left;
        width:37%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 992px) and (max-width: 1035px) {
    .inputs-form {
        float:left;
        width:36%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1359px){
    .inputs-form {
        float:left;
        width:41%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 10px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 12px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input, textarea {
    background-color: rgba(249, 250, 252, 1);
}
::v-deep .ui.search.dropdown>.text {
    overflow: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
}
.StepProgress {
    position: relative;
    padding-left: 45px;
    list-style: none;
}
.StepProgress::before {
    display: inline-block;
    content: '';
    position: absolute;
    top: 5px;
    left: 15px;
    width: 10px;
    height: 80%;
    border-left: 2px solid #CCC;
}
.StepProgress-item {
    position: relative;
    counter-increment: list;
}
.StepProgress-item:not(:last-child) {
    padding-bottom: 20px;
}
.StepProgress-item::before {
    display: inline-block;
    content: '';
    position: absolute;
    top: 10px;
    left: -30px;
    height: 100%;
    width: 10px;
}
.StepProgress-item::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 5px;
    left: -35px;
    width: 12px;
    height: 12px;
    border: 2px solid #CCC;
    border-radius: 50%;
    background-color: #FFF;
}
.StepProgress-item.is-done::before {
    border-left: 2px solid rgba(21, 100, 153, 1);
}
.StepProgress-item.is-done::after {
    font-size: 10px;
    color: #FFF;
    text-align: center;
    border: 2px solid rgba(21, 100, 153, 1);
    background-color: rgba(21, 100, 153, 1);
}
.StepProgress strong {
    display: block;
}
label{
	margin: 0;
}
::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
.modal-buttons {
    width:156px;
    height: 36px;
}
.modal-button-cancel {
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: white;
    color: rgba(16, 16, 16, 1);
}
.modal-button-cancel:hover {
    border: 1px solid rgba(48, 107, 240, 1);
    background-color: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.modal-button-simpan {
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.modal-button-simpan:hover {
    border: 1px solid rgba(48, 107, 240, 1);
    background-color: rgba(48, 107, 240, 1);
    color: white;
}
.btn-add {
    border-radius: 4px;
    width: 160px;
    float:right;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 160px;
    float:right;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-search {
    border-radius: 4px;
    float: right;
    width: 160px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    float: right;
    width: 160px;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}
.cards-image {
    position: absolute;
    text-align: center;
    font-size: 27px;
    color: rgba(96, 96, 96, 1);
    line-height: 50px;
    border: 1px dotted rgba(221, 221, 221, 1);
    width: 56px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 56px !important;
}
.cards-image-invalid {
    position: absolute;
    text-align: center;
    font-size: 27px;
    color: rgba(96, 96, 96, 1);
    line-height: 50px;
    border: 1px dotted #e55353 !important;
    width: 56px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 56px !important;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
</style>